import { Magic } from "magic-sdk";
import { ethers } from "ethers";
import { ConnectExtension } from "@magic-ext/connect";
const magicKey = process.env.REACT_APP_MAGIC_PUBLISHABLE_KEY || "";

export const getMagic = async () => {
  const networks = {
    rpcUrl: "https://rpc-mumbai.maticvigil.com/",
    chainId: 80001,
  };
  const magic2 = new Magic(magicKey, {
    network: networks,
    extensions: [new ConnectExtension()],
  });
  let userData = JSON.parse(localStorage.getItem("userData"));
  let email = userData?.email;
  // let didToken=true;
  let didToken = await magic2?.auth.loginWithEmailOTP({ email });
  if (didToken) {
    const magicProvider = new ethers.providers.Web3Provider(magic2.rpcProvider);
    const magicSigner = magicProvider.getSigner();

    return [magicSigner, magicProvider];
  } else {
    console.log("error");
  }
};
export const getMagic1 = () => {
  const networks = {
    rpcUrl: "https://rpc-mumbai.maticvigil.com/",
    chainId: 80001,
  };
  const magic2 = new Magic(magicKey, {
    network: networks,
    extensions: [new ConnectExtension()],
  });

  // let didToken=true;

  const magicProvider = new ethers.providers.Web3Provider(magic2.rpcProvider);
  const magicSigner = magicProvider.getSigner();
  return [magicSigner, magicProvider];
};
